module.exports = __webpack_public_path__ + "static/media/picto_fleche_equipe.9651e5e6.svg";